import { Row } from '@tanstack/react-table';
import {
  AdminActions,
  AdministratorRoleApiModel,
  AdministratorUserApiModel,
  BaseAdmin,
} from '../AdminsTab/models';

export interface InternalAdminModel extends AdministratorUserApiModel {}

export interface InternalAdminRoleModel extends AdministratorRoleApiModel {}

export interface BaseInternalAdmin extends BaseAdmin {
  accountUserId?: string;
  name?: string;
  accessType?: string;
  role?: string;
}

export type ModifyInternalAdminFunc = (
  admin: InternalAdminModel | undefined,
) => void;

export interface InternalAdminActions extends AdminActions {}

export interface TableCellProps {
  row: Row<InternalAdminModel> | { original: InternalAdminModel };
  actions?: InternalAdminActions;
  isDeveloper?: boolean;
  currentAccountEmail?: string;
}
export const emptyInternalAdmin: BaseInternalAdmin = {
  email: '',
  invitationEmail: '',
  accountRole: '',
  accountUserId: '',
  name: '',
};
